import { PayloadAction } from '@reduxjs/toolkit';

import { SET_SITEWIDE_BANNER } from '@/types/store/actions';
import { SitewideBanner } from '@/types/store/reducers';

const initialState: SitewideBanner = {
	bannerCode: undefined,
	bannerInfo: null,
};

export function sitewideBannerReducer(
	state = initialState,
	action: PayloadAction<SitewideBanner>,
): SitewideBanner {
	switch (action.type) {
		case SET_SITEWIDE_BANNER:
			return action.payload;
		default:
			return state;
	}
}
